<section class="current-order-section">
  <div class="current-order-content-container">
    <app-current-orders-progress [isGroup]="isGroup"
                                 [isSpecial]="specialLocation"
                                 class="order-progress">
    </app-current-orders-progress>
    <app-current-orders-ready [isGroup]="isGroup"
                              [isSpecial]="specialLocation"
                              class="order-ready">
    </app-current-orders-ready>
  </div>
  <app-current-orders-footer [isGroup]="isGroup">
  </app-current-orders-footer>
</section>
